import { Box, Text, Heading, Image, Flex } from '@everlywell/ui-kit';
import React from 'react';

export interface StepCardProps {
  card: {
    heading: string;
    description: {
      childMarkdownRemark: {
        rawMarkdownBody: string;
      };
    };
    image?: { url: string };
  };
  index: number;
  isLastCard: boolean;
}

const StepCard: React.FC<StepCardProps> = ({ card, index, isLastCard }) => {
  // Handle missing card data
  if (!card) {
    return null;
  }

  // Safely access nested properties
  const heading = card.heading || '';
  const description =
    card?.description?.childMarkdownRemark?.rawMarkdownBody || '';
  const imageUrl = card?.image?.url || '';

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      height="100%"
    >
      <Flex alignItems="center" gap={4} w="100%">
        <Box
          bg="#E8E8E2"
          borderRadius="8px"
          width="32px"
          height="28px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          aria-label={`Step ${index + 1}`}
        >
          <Text fontSize="xs" fontWeight="bold">
            {index + 1}
          </Text>
        </Box>
        {!isLastCard && <Box w="100%" h="1px" bg="#E8E8E2" />}
      </Flex>
      <Box mt={5} flex="1">
        {heading && <Heading fontSize="xl">{heading}</Heading>}
        {description && (
          <Text
            color="#545454"
            mt={2}
            fontSize="15px"
            lineHeight="21px"
            fontWeight="400"
          >
            {description}
          </Text>
        )}
      </Box>
      {imageUrl && (
        <Image
          data-testid="step-card-image"
          src={imageUrl}
          alt={`${heading} illustration`}
          width="100%"
          borderRadius="8px"
          mt={6}
        />
      )}
    </Box>
  );
};

export default React.memo(StepCard);
